import { render, staticRenderFns } from "./lkuBankAccUserLazzy.vue?vue&type=template&id=e80852a8"
import script from "./lkuBankAccUserLazzy.vue?vue&type=script&lang=js"
export * from "./lkuBankAccUserLazzy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports